<template>
  <component :is="iconComponent" class="w-5 h-5" :title="displayName" />
</template>

<script setup lang="ts">
import { UserIcon, GlobeAltIcon, BuildingOfficeIcon } from '@heroicons/vue/24/outline'
import { DeckBaseAccess } from '~~/entities/deck'

interface Props {
  accessType: DeckBaseAccess
}

const props = defineProps<Props>()

const iconComponent = computed(() => {
  switch (props.accessType) {
    case DeckBaseAccess.Public:
      return GlobeAltIcon
    case DeckBaseAccess.Private:
      return UserIcon
    case DeckBaseAccess.CompanyView:
    case DeckBaseAccess.CompanyEdit:
      return BuildingOfficeIcon
    default:
      return UserIcon
  }
})

const VIEW_ACCESS_TYPE_DISPLAY_MAP: Record<DeckBaseAccess, string> = {
  [DeckBaseAccess.Public]: 'Anyone with the link',
  [DeckBaseAccess.Private]: 'Only people invited',
  [DeckBaseAccess.CompanyView]: 'Everyone at company',
  [DeckBaseAccess.CompanyEdit]: 'Everyone at company',
}

const displayName = computed(() => {
  return VIEW_ACCESS_TYPE_DISPLAY_MAP[props.accessType] || 'Unknown'
})
</script>
